export default "__VITE_ASSET__Ddqion1O__"